import {
  Box,
  BoxProps,
  Flex,
  Heading,
  Icon,
  smBumps,
  Typo,
  xsBumps,
} from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent } from 'react'

import { useHelpLink } from '../../../hooks/navigation'
import { TKeyBuilder } from '../../../infrastructure/internationalisation'
import { InputConfig } from '../../../state/configuration'
import { ContextualHelpLink, HelpFlexAnchor } from '../../organisms/links'
import { WriskTrans } from '../../organisms/trans'

export interface FormHeaderProps extends BoxProps {
  input: InputConfig
  controllerName: string
  tKey: TKeyBuilder
  t: TFunction
}

export const FormHeader: FunctionComponent<FormHeaderProps> = ({
  input: { options, name },
  controllerName,
  tKey,
  t,
  ...props
}) => {
  const helpLink = useHelpLink(name)

  const header = t(tKey(name, 'header'), { defaultValue: null })

  const subheader = t(tKey(name, 'subheader'), {
    defaultValue: null,
    returnDetails: true,
  })

  const helpLinkId = options?.helpLink ? `${controllerName}_help_link` : undefined

  return header ? (
    <Box width={1} {...props}>
      <Flex width={1}>
        {header && (
          <Heading
            aria-details={helpLinkId}
            id={`${controllerName}_header`}
            variant='h3'
            as='h3'
            typoSize='md'
          >
            {header}
          </Heading>
        )}
        {options?.helpLink && (
          <HelpFlexAnchor
            aria-label={`${controllerName} help`}
            id={helpLinkId}
            variant='highlight'
            borderRadius='50%'
            justifyContent='center'
            ml={smBumps}
            p={1}
            href={helpLink}
          >
            <Icon icon='help' size='small' />
          </HelpFlexAnchor>
        )}
      </Flex>
      {subheader.res && (
        <Typo color='bodySecondary' whiteSpace='pre-line' mt={xsBumps}>
          <WriskTrans
            t={t}
            i18nKey={subheader.exactUsedKey}
            components={{
              ContextualHelp: <ContextualHelpLink name={name} />,
            }}
            values={{ name }}
          />
        </Typo>
      )}
    </Box>
  ) : null
}
